export default __webpack_public_path__ + "static/media/Rooster_s Crow.04b7fdf6.png";